export default function ensureIntlSupport(initialLanguageCode) {
  if (window.Intl) return Promise.resolve()
  let targetLocale
  switch (initialLanguageCode) {
    case 'en':
      targetLocale = import('intl/locale-data/jsonp/en.js')
    case 'da':
      targetLocale = import('intl/locale-data/jsonp/da.js')
    case 'de':
      targetLocale = import('intl/locale-data/jsonp/de.js')
    case 'fr':
      targetLocale = import('intl/locale-data/jsonp/fr.js')
    case 'it':
      targetLocale = import('intl/locale-data/jsonp/it.js')
    case 'nl':
      targetLocale = import('intl/locale-data/jsonp/nl.js')
    case 'pl':
      targetLocale = import('intl/locale-data/jsonp/pl.js')
    case 'pt':
      targetLocale = import('intl/locale-data/jsonp/pt.js')
    case 'ru':
      targetLocale = import('intl/locale-data/jsonp/ru.js')
    case 'sv':
      targetLocale = import('intl/locale-data/jsonp/sv.js')
    default:
      targetLocale = import('intl/locale-data/jsonp/en.js')
  }
  return new Promise((resolve) => {
    // eslint-disable-next-line global-require
    resolve(require('intl'))
  })
  .then(() => Promise.all([
    targetLocale,
  ]))
}
